import auth from './auth';
import fileProgress from './file-progress';
import layout from './layout';
import navbar from './navbar';
export const authReducer = {
  auth,
  navbar,
  layout,
  fileProgress
};
